import { render, staticRenderFns } from "./CmgNotificationBar.vue?vue&type=template&id=5ec2dbf7&scoped=true&lang=pug"
import script from "./cmg-notification-bar.ts?vue&type=script&lang=ts&external"
export * from "./cmg-notification-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNotificationBar.vue?vue&type=style&index=0&id=5ec2dbf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec2dbf7",
  null
  
)

export default component.exports